export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11290.fce8c4e3.jpg";